import React from 'react'

function Tabs({ langLocal,tabs, handleSectionClick, activeSection, setActiveId, setOrderId }) {
    return (
        <div className='div_tabs' >
            {
                tabs.map((tab) => {
                    return (
                        <span className={` ${activeSection === `${tab.type}` ? 'tab_active' : ""}`} onClick={() => {
                            handleSectionClick(tab.type);
                            if(tab.type === 'Requests'){setActiveId(null)}
                            if(tab.type === 'Delivery'){setOrderId(null)}
                        }} >
                            <i className={`${tab.icon} ${langLocal === 'en'? 'margin_right_10' : 'margin_left_10'}`} ></i>
                            <p>{tab.name}</p>
                        </span>
                    )
                })
            }
        </div>
    )
}

export default Tabs